import React from 'react'
import './Hero.css'
import dark_arrow from '../Assets/dark_arrow.png'
import hero_image from '../Assets/hero.png'

const Hero = () => {
  return (
    <div className='hero'>

      <div className='hero-left'>
        
        <div>

            <h2>Enter the Shoppe to find the curios you didn't know you seek</h2> <br></br>
            <p>We aim to provide you with products and experiences that are out of the ordinary and allow a break from the monotony of day to day living</p>

        </div>

        <a href='/BoardGames' className="hero-btn"> 
            <div>Enter if you dare...</div>
            <img src={dark_arrow} alt="Arrow"/> 
        </a>

      </div>      

      <div className="hero-right">

        <img src={hero_image} alt="" />

      </div>
        
    </div>
  )
}

export default Hero
